import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import 'rxjs';
declare var $:any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  title = 'Log in to your account';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{0,2}$";
  constructor(private httpClient: HttpClient) { }

  ngOnInit() {

  }
  loginObj = {
    remember: 1,
    select: 0
  };
  status = {
    type: '',
    message: '',
    sending: false
  };

  //close login modal and open sign up modal
  signUpModal() {
    $('#loginModal').modal('hide');
    $('#signUpModal').modal('show').on('shown.bs.modal', function () {
      $('body').addClass('modal-open');
    });
  }

  //close login modal and open forgot password modal
  forgotPasswordModal() {
    $('#loginModal').modal('hide');
    $('#forgotPasswordModal').modal('show').on('shown.bs.modal', function () {
      $('body').addClass('modal-open');
    });
  }

  logInForm(form) {
    let payload, endpoint, headers;

    endpoint = 'http://www.benutech.com/login';
    // headers = new HttpHeaders().set('Authorization', 'auth-token');

    if (form.invalid) {
      this.status = {
        type: 'error',
        sending: false,
        message: 'please correct the red marked fields first.'
      };
      return;
    }

    //this.status.sending = true;

    payload = JSON.stringify(this.loginObj);

    this.httpClient.post(endpoint, payload)
      .subscribe((data:any) => {

        if(data.status != 0) {
          this.status.type = "success";
          this.status.message = "Login successfully.";
        } else {
          this.status.type = "error";
          this.status.message = "Login Failed!";
        }

        this.status.sending = false;
      });
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/login/login.component.ts